import React, { useRef, useState, useEffect } from "react";
import { Tooltip, type TooltipProps } from "@mui/material";

interface EllipsisWithTooltipProps {
  children: React.ReactNode;
  placement?: TooltipProps["placement"];
}

export const EllipsisWithTooltip = ({ children, placement = "top" }: EllipsisWithTooltipProps) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      const isTruncatedNow = element.scrollWidth > element.clientWidth || element.offsetWidth < element.scrollWidth;
      setIsTruncated(isTruncatedNow);
    }
  }, [children]);

  return (
    <Tooltip
      title={children}
      placement={placement}
      disableHoverListener={!isTruncated}
      enterDelay={300}
      enterNextDelay={300}
    >
      <span
        ref={textRef}
        style={{
          display: "inline-block",
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          verticalAlign: "bottom",
          lineHeight: "inherit",
        }}
      >
        {children}
      </span>
    </Tooltip>
  );
};
